import { useState } from 'react';
import { Tooltip, List, Button, Typography } from 'antd';
import { forwardTo } from 'utils/common/route';
import classnames from 'classnames';
import QaSpecWorkflowReasonModal from './QaSpecWorkflowReasonModal';
import { useActionWorkflow } from 'pages/qa-spec-workflow/hook';
import { useCheckPermissions } from 'hooks';
import {
  PERMISSION_MANAGE_QA_SPEC_WORKFLOW,
  PERMISSION_VIEW_QA_SPECIFICATION,
} from 'static/Permission';

const { Title, Text } = Typography;

const QaSpecWorkflowItem = ({ workflowItem, setVisible }) => {
  const productName = workflowItem.productName;
  const name = workflowItem?.upc12 || workflowItem?.gtin;
  const qaSpecNameApproval = `${name ?? ''} QA Spec Approval`;

  const [showModalReason, setShowModalReason] = useState(false);

  const hasPermissionManageQaSpecWorkflow = useCheckPermissions(
    PERMISSION_MANAGE_QA_SPEC_WORKFLOW
  );
  const hasPermissionViewQaSpec = useCheckPermissions(
    PERMISSION_VIEW_QA_SPECIFICATION
  );

  const onClickViewItem = (workflowId) => {
    forwardTo(`/product/qa-specification/${workflowId}`);
    setVisible(false);
  };

  const { onApproveWorkflow, onRejectWorkflow } = useActionWorkflow({
    setShowModalReason,
    workflowId: workflowItem?.id,
    setVisible,
  });

  const renderButtonQASpecWorkflow = (status) => {
    if (!hasPermissionManageQaSpecWorkflow) return null;

    return (
      <>
        {hasPermissionViewQaSpec && (
          <Button
            style={{ borderRadius: '4px', marginRight: '10px' }}
            onClick={() => onClickViewItem(workflowItem?.id)}
            type='primary'
          >
            View
          </Button>
        )}
        {status?.toLowerCase() === 'submitted' ? (
          <>
            <Button
              onClick={() => onApproveWorkflow(workflowItem?.id)}
              style={{ borderRadius: '4px' }}
              type='primary'
              className='header-task__popover-item--accept-button'
            >
              Approve
            </Button>
            <Button
              style={{ borderRadius: '4px' }}
              onClick={() => setShowModalReason(true)}
              danger
            >
              Reject
            </Button>
          </>
        ) : (
          <span>
            {status?.toLowerCase() === 'approved' ? 'Approved' : 'Rejected'}
          </span>
        )}
      </>
    );
  };

  const renderProductName = (title) => {
    if (!title) return null;

    const shouldShowTooltip = title.length > 30;

    return (
      <Tooltip title={shouldShowTooltip ? title : ''}>
        <Title
          ellipsis={{ tooltip: shouldShowTooltip }}
          level={5}
          style={{
            fontSize: '12px',
            fontWeight: 600,
            color: 'rgba(0, 0, 0, 0.85)',
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </Title>
      </Tooltip>
    );
  };

  return (
    <>
      <List.Item
        className='header-task__popover-item'
        extra={renderButtonQASpecWorkflow(workflowItem?.status)}
      >
        <List.Item.Meta
          title={renderProductName(productName)}
          description={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Text
                type='secondary'
                style={{
                  fontSize: '12px',
                  maxWidth: '200px',
                  color: 'rgba(0, 0, 0, 0.6)',
                }}
              >
                {qaSpecNameApproval}
              </Text>
              <div
                style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}
              >
                <div
                  className={classnames(
                    'header-task__popover-item--status-dot',
                    {
                      'accepted-dot':
                        workflowItem?.status?.toLowerCase() === 'accepted',
                      'waiting-dot':
                        workflowItem?.status?.toLowerCase() === 'submitted',
                    }
                  )}
                ></div>
                <Text style={{ marginLeft: 8 }}>{workflowItem?.status}</Text>
              </div>
            </div>
          }
        />
      </List.Item>

      {showModalReason && (
        <QaSpecWorkflowReasonModal
          onRejectTodo={onRejectWorkflow}
          showModalReason={showModalReason}
          setShowModalReason={setShowModalReason}
        />
      )}
    </>
  );
};

export default QaSpecWorkflowItem;
